import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Input,
  Select,
  Flex,
  Switch,
  Typography,
} from "antd";
import { useEffect, useState, useCallback, useMemo } from "react";
import {
  ReloadOutlined,
  FileAddOutlined,
  PlusOutlined,
  BarcodeOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import {
  GET_MAIN_OLD_DATA,
  HEADERS_EXPORT_BEN,
  POST_ROUND_AGREEMENT,
} from "../../API/apiUrls";
import axios from "axios";
import dayjs from "dayjs";
import MotionHoc from "../../../utils/MotionHoc";
import BillAfterCourtOldData from "./modal/BillAfterCourtOldData";
import EditJudgment from "./componentsEditJudgment/EditJudgment";
import AddEmsAndExport from "./modal/AddEmsAndExport";
import ThaiDatePicker from "../../../hook/ThaiDatePicker";

const { Option } = Select;
const { Text } = Typography;

const Main = () => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const roleId = localStorage.getItem("ROLE_ID");

  // States
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInputTable, setSearchInputTable] = useState("");
  const [processStatus, setProcessStatus] = useState(
    roleId === "12" ? "1" : "null",
  );
  const [dataRecord, setDataRecord] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [isModalAddEms, setIsModalAddEms] = useState(false);

  // Selection states
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dateRound, setDateRound] = useState(dayjs());
  const [dataEms, setDataEms] = useState([]);

  const [showDate, setShowDate] = useState(false);
  const [showEditJudgment, setShowEditJudgment] = useState(false); // ✅ State สำหรับเปลี่ยนหน้า

  // ✅ โหลดข้อมูลหลัก
  const loadMain = useCallback(async () => {
    setLoading(true);
    const controller = new AbortController();

    try {
      const res = await axios.get(GET_MAIN_OLD_DATA, {
        headers: HEADERS_EXPORT_BEN,
        signal: controller.signal,
      });

      if (res.data && res.data.length > 0) {
        filterEms(res.data);
        setDataArr(res.data);
      } else {
        setDataArr([]);
        message.info("ไม่มีข้อมูล");
      }
    } catch (error) {
      if (error.name !== "CanceledError") {
        console.error("❌ Error loading data:", error);
        const errorMsg =
          error.response?.data?.message ||
          error.message ||
          "ไม่สามารถโหลดข้อมูลได้";
        message.error(errorMsg);
        setDataArr([]);
      }
    } finally {
      setLoading(false);
    }

    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    loadMain();
  }, [loadMain]);

  // ✅ ฟังก์ชันสำหรับสร้าง Options ของ Select
  const statusOptions = useMemo(
    () => [
      { value: "99", icon: "🗂️", label: "ทั้งหมด" },
      { value: "null", icon: "🕒", label: "รอตรวจสอบ" },
      { value: "1", icon: "✅", label: "ตรวจสอบแล้ว" },
      { value: "97", icon: "🕒📮", label: "รอส่ง EMS" },
      { value: "98", icon: "📮", label: "ส่ง EMS แล้ว" },
    ],
    [],
  );

  const filterEms = (data) => {
    const preData = data.filter((item) => item.roundDate);
    setDataEms(preData);
  };

  // ✅ กรองข้อมูลอัตโนมัติด้วย useMemo
  const arrayTable = useMemo(() => {
    if (!dataArr || dataArr.length === 0) return [];

    const normalize = (value) =>
      String(value ?? "")
        .trim()
        .toLowerCase();

    const searchQuery = normalize(searchInputTable);

    const filtered = dataArr.filter((item) => {
      const passQuery =
        !searchQuery ||
        [
          item.parcelNo,
          item.newContno,
          item.CUSCOD,
          item.CONTNO,
          item.NAME1,
          item.NAME2,
          `${item.SNAM || ""}${item.NAME1 || ""} ${item.NAME2 || ""}`,
        ]
          .map(normalize)
          .some((val) => val.includes(searchQuery));

      let passStatus = true;

      if (processStatus && processStatus !== "99") {
        if (processStatus === "97") {
          passStatus =
            !item.roundDate && item.checkJudge && item.flagLoanNew === 1;
        } else if (processStatus === "98") {
          passStatus = item.roundDate !== null && item.roundDate !== undefined;
        } else {
          const statusValues = processStatus.split(",");
          const checkValue =
            item.checkJudge === null || item.checkJudge === undefined
              ? "null"
              : String(item.checkJudge);
          passStatus = statusValues.includes(checkValue);
        }
      }

      return passQuery && passStatus;
    });

    // ✅ sort มากไปน้อย เฉพาะ processStatus === "98"
    if (processStatus === "98") {
      return filtered.sort(
        (a, b) => dayjs(b.roundDate).valueOf() - dayjs(a.roundDate).valueOf(),
      );
    }

    return filtered;
  }, [dataArr, searchInputTable, processStatus]);

  // ✅ ฟังก์ชันล้างฟิลเตอร์
  const handleResetFilter = useCallback(() => {
    setSearchInputTable("");
    setProcessStatus("99");
    message.info("ล้างตัวกรองสำเร็จ");
  }, []);

  // ✅ เปิดหน้า CreateJudgment
  const handleOpenJudgment = useCallback((record) => {
    console.log("ลงคำพิพากษา:", record);
    setDataRecord(record);
    setShowEditJudgment(true);
  }, []);

  // ✅ ปิดหน้า CreateJudgment และกลับมาที่หน้า Table
  const handleCloseJudgment = useCallback(() => {
    setShowEditJudgment(false);
    setDataRecord(null);
  }, []);

  // ✅ ปิดหน้า CreateJudgment และกลับมาที่หน้า Table
  const handleReloadJudgment = useCallback(() => {
    setShowEditJudgment(false);
    setDataRecord(null);
    loadMain(); // โหลดข้อมูลใหม่
  }, [loadMain]);

  // ✅ Columns สำหรับตาราง
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 80,
      render: (_, __, index) => index + 1,
    },
    // {
    //   title: "เลขสัญญา",
    //   dataIndex: "CONTNO",
    //   key: "CONTNO",
    //   align: "center",
    //   width: 150,
    // },
    {
      title: "เลขสัญญาใหม่",
      dataIndex: "newContno",
      key: "newContno",
      align: "center",
      width: 150,
    },
    {
      title: "ชื่อ-นามสกุล",
      key: "fullName",
      align: "center",
      render: (_, record) => (
        <span>
          {`${record.SNAM || ""}${record.NAME1 || ""} ${
            record.NAME2 || ""
          }`.trim()}
        </span>
      ),
    },
    {
      title: "คำสั่งศาล",
      key: "name",
      align: "center",
      render: (_, r) => (
        <Tag color={r.flagLoanNew === 1 ? "green" : "red"}>
          {r.flagLoanNew === 1 ? "ทำยอม" : "พิพากษา"}
        </Tag>
      ),
    },
    {
      title: "รอบส่ง EMS",
      key: "name",
      align: "center",
      render: (_, r) =>
        r.roundDate
          ? dayjs(r.roundDate).add(543, "year").format("DD MMM YY")
          : "-",
    },
    {
      title: "เลขไปษณีย์",
      key: "name",
      align: "center",
      render: (_, r) => (
        <Tag>
          <Text strong copyable={r.parcelNo}>
            {r.parcelNo ? r.parcelNo : "-"}
          </Text>
        </Tag>
      ),
    },
    {
      title: "การจัดการ",
      key: "actions",
      align: "center",
      width: 180,
      render: (_, record) => {
        const { checkJudge } = record;
        if (!checkJudge) {
          return (
            <Button
              type="primary"
              ghost
              icon={<FileAddOutlined />}
              disabled={roleId === "12"}
              onClick={() => {
                // setDataRecord(record);
                // setIsModal(true);
                handleOpenJudgment(record);
              }}
            >
              ตรวจสอบข้อมูล
            </Button>
          );
        } else {
          return (
            <Space direction="vertical">
              <Button
                color="green"
                variant="outlined"
                icon={<FileAddOutlined />}
                onClick={() => {
                  setDataRecord(record);
                  setIsModal(true);
                }}
              >
                ดูข้อมูล
              </Button>
              <Button
                variant="outlined"
                color="orange"
                ghost
                disabled={roleId === "12" || record.flagPay === 1}
                onClick={() => {
                  handleOpenJudgment(record);
                }}
              >
                ✏️ แก้ไขข้อมูล
              </Button>
            </Space>
          );
        }
      },
    },
  ].filter(Boolean);

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleDataQuery = async () => {
    if (!selectedRows?.length) {
      message.warning("กรุณาเลือกรายการก่อน");
      return;
    }

    const payload = {
      id: selectedRows.map((row) => row.idJudge),
      roundDate: dateRound,
    };
    console.log("selectedRows", selectedRows);

    console.log("payload", payload);

    await insertData(payload);
  };

  const insertData = async (payload, opts = {}) => {
    const { silence = false } = opts;
    setLoading(true);

    try {
      const res = await axios.post(POST_ROUND_AGREEMENT, payload, {
        headers: HEADERS_EXPORT_BEN,
      });

      const data = res.data;

      if (!data || (Array.isArray(data) && data.length === 0)) {
        if (!silence) message.warning("ไม่พบข้อมูล");
        return Array.isArray(data) ? data : [];
      }

      if (!silence) message.success("ดำเนินการสำเร็จ");
      loadMain(); // ✅ โหลดเฉพาะตอนสำเร็จ
      return data;
    } catch (err) {
      const status = err?.response?.status;
      console.error("insertData error:", err);
      if (!silence) {
        message.error(`เกิดข้อผิดพลาด${status ? ` (${status})` : ""}`);
      }
      return null;
    } finally {
      setLoading(false);
      clearSelectedRows();
    }
  };

  const clearSelectedRows = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
  };

  // ✅ แสดง CreateJudgment แทน Table
  if (showEditJudgment && dataRecord) {
    return (
      <EditJudgment
        dataDefault={dataRecord}
        onClose={handleCloseJudgment}
        funcUpdateStatus={handleReloadJudgment}
      />
    );
  }

  return (
    <Card>
      <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
        <Row gutter={[0, 16]}>
          {/* Filters */}
          <Col span={16}>
            <Space size={10} wrap>
              <Select
                size="large"
                style={{ minWidth: 180 }}
                placeholder="เลือกสถานะ"
                value={processStatus}
                onChange={(value) => {
                  setProcessStatus(value);
                  clearSelectedRows();
                }}
              >
                {statusOptions.map(({ value, icon, label }) => (
                  <Option key={value} value={value}>
                    <span style={{ marginRight: 8 }}>{icon}</span>
                    {label}
                  </Option>
                ))}
              </Select>

              <Input
                placeholder="ค้นหาเลขสัญญา, ชื่อ"
                value={searchInputTable}
                onChange={(e) => setSearchInputTable(e.target.value)}
                style={{ width: 250, borderRadius: 8 }}
                size="small"
                allowClear
                suffix={<span style={{ marginRight: 5 }}>🔍</span>}
              />

              <Button
                icon={<ReloadOutlined />}
                onClick={handleResetFilter}
                size="large"
                style={{
                  borderRadius: 8,
                  backgroundColor: "#fff1f0",
                  borderColor: "#ffa39e",
                  color: "#cf1322",
                }}
              >
                ล้างตัวกรอง
              </Button>
            </Space>
          </Col>
          <Col span={8} style={{ textAlign: "right" }}>
            <Space size={10}>
              <Switch
                checked={showDate}
                onChange={setShowDate}
                checkedChildren="เลือกวันที่"
                unCheckedChildren="เลือกวันที่"
              />
              <Space size={5} direction="vertical">
                <Button
                  color="blue"
                  variant="filled"
                  icon={<PlusOutlined />}
                  size="large"
                  onClick={() => handleDataQuery()}
                  disabled={
                    selectedRows.length === 0 ||
                    selectedRows.some(
                      (item) =>
                        item.roundDate ||
                        !item.checkJudge ||
                        item.flagLoanNew === 2,
                    )
                  }
                  loading={loading}
                  style={{ borderRadius: 8 }}
                >
                  บันทึกรอบส่ง
                  {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length})`}
                </Button>

                {showDate && (
                  <ThaiDatePicker
                    value={dateRound}
                    onChange={setDateRound}
                    placeholder="กรุณาเลือกวันที่"
                    size="large"
                    style={{ width: "100%" }}
                    suffixIcon={<CalendarOutlined />}
                  />
                )}
              </Space>
              <Button
                type="primary"
                danger
                icon={<BarcodeOutlined />}
                onClick={() => setIsModalAddEms(true)}
                disabled={loading}
                loading={loading}
              >
                นำเข้าเลขไปรษณีย์
              </Button>
            </Space>
          </Col>
          {/* Table */}
          <Col span={24}>
            <Table
              size="small"
              columns={columns}
              dataSource={arrayTable}
              rowKey={(record) => record.CONTNO || record.id}
              scroll={{ x: 1000 }}
              rowSelection={rowSelection}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                showTotal: (total) => `ทั้งหมด ${total} รายการ`,
                pageSizeOptions: ["10", "20", "50", "100"],
              }}
              footer={() => (
                <Flex
                  justify="space-between"
                  align="center"
                  style={{ fontWeight: 500 }}
                >
                  <span
                    style={{
                      color: selectedRowKeys.length > 0 ? "#1890ff" : "#999",
                    }}
                  >
                    {selectedRowKeys.length > 0
                      ? `✓ เลือกแล้ว ${selectedRowKeys.length} สัญญา`
                      : "ยังไม่ได้เลือกสัญญา"}
                  </span>
                  <span>จำนวนสัญญาทั้งหมด: {arrayTable.length} รายการ</span>
                </Flex>
              )}
            />
          </Col>
        </Row>
      </Spin>
      {isModal && (
        <BillAfterCourtOldData
          open={isModal}
          close={() => setIsModal(false)}
          dataDefault={dataRecord}
        />
      )}
      {isModalAddEms && (
        <AddEmsAndExport
          open={isModalAddEms}
          close={() => setIsModalAddEms(false)}
          dataDefault={dataEms}
          onRefresh={loadMain} // ✅ ส่งมาจาก parent
        />
      )}
    </Card>
  );
};

const BillAfterCourt = MotionHoc(Main);
export default BillAfterCourt;
